import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=21643ac4&scoped=true"
import script from "./SSO.vue?vue&type=script&lang=ts"
export * from "./SSO.vue?vue&type=script&lang=ts"
import style0 from "./SSO.vue?vue&type=style&index=0&id=21643ac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21643ac4",
  null
  
)

export default component.exports